import { useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

// const url = "https://ekart-express-api.herokuapp.com/api/v1/orders";

function Checkout() {
  const [warning, setWarning] = useState("");
  const navigate = useNavigate();

  const nameRef = useRef();
  const mobileRef = useRef();
  const addressRef = useRef();
  const pincodeRef = useRef();
  const landMarkRef = useRef();

  /**
   * @desc    Function to place an order
   */
  const placeOrder = async () => {
    const orderObj = {
      name: "",
      mobile: "",
      address: "",
      pincode: "",
      landMark: "",
    };

    orderObj.name = nameRef.current.value;
    orderObj.mobile = mobileRef.current.value;
    orderObj.address = addressRef.current.value;
    orderObj.pincode = pincodeRef.current.value;
    orderObj.landMark = landMarkRef.current.value;

    if (
      orderObj.name === "" ||
      orderObj.mobile === "" ||
      orderObj.address === "" ||
      orderObj.pincode === ""
    ) {
      setWarning("All the fields except Landmark are mandatory!");
      return;
    }

    navigate("/place-order", {
      state: orderObj,
    });
  };

  return (
    <div className="container" style={{ marginTop: "8rem" }}>
      <form
        className="border border-primary"
        style={{
          margin: "2rem",
          border: "1px solid lightgray",
          padding: "2rem",
          borderRadius: "1rem",
        }}
      >
        <div className="mb-3">
          <label htmlFor="name" className="form-label">
            Full Name
          </label>
          <input
            type="text"
            className="form-control"
            id="name"
            placeholder="Enter full name"
            ref={nameRef}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="mobile" className="form-label">
            Mobile
          </label>
          <input
            type="text"
            className="form-control"
            id="mobile"
            placeholder="Enter mobile number"
            ref={mobileRef}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="address" className="form-label">
            Address
          </label>
          <input
            type="text"
            className="form-control"
            id="address"
            placeholder="Enter your address"
            ref={addressRef}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="pincode" className="form-label">
            Pincode
          </label>
          <input
            type="text"
            className="form-control"
            id="pincode"
            placeholder="Enter pincode"
            ref={pincodeRef}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="landmark" className="form-label">
            Landmark
          </label>
          <input
            type="text"
            className="form-control"
            id="landmark"
            placeholder="Enter a landmark if any"
            ref={landMarkRef}
          />
        </div>

        <div className="d-flex justify-content-center d-grid gap-2">
          <button
            className="btn btn-primary"
            type="button"
            style={{ width: "80%" }}
            onClick={placeOrder}
          >
            <Link
              style={{ textDecoration: "none", color: "#fff" }}
              to="/place-order"
            >
              Proceed to checkout
            </Link>
          </button>
        </div>
      </form>
      <div>
        {warning ? (
          <p className="alert alert-danger" role="alert">
            {warning}
          </p>
        ) : null}
      </div>
    </div>
  );
}

export default Checkout;
